import api, { getParams } from './'

const bookingEndpoints = {
  encryptToken: token => api.post(`booking/etoken`, { token }),
  createBookingRequest: data => api.post(`booking/request`, data),
  bookTravelCurious: data => api.post(`booking/tc/book`, data),
  requestViatorVC: data => api.post(`booking/viator/book`, data),
  bookHotelPlanner: data => api.post(`booking/hp/book`, data),
  getHotelPlannerReservationStatus: reservation_id => api.get(`booking/hp/reservation/${reservation_id}/status`),
  requestHotelPlannerCancellation: (reservation_id, itinerary_number) => api.post(`booking/hp/reservation/${reservation_id}/itinerary/${itinerary_number}/cancel`),
  requestPartnerVC: data => api.post(`booking/partner/book`, data),
  requestFlightVC: data => api.post(`booking/flight/book`, data),
  requestAffiliateVCC: data => api.post(`booking/affiliate/book`, data),
  requestGeneralVC: data => api.post(`booking/generic/book`, data),
  bookHolibob: (data, bookingID) => api.post(`booking/holi/book/${bookingID}`, data),
  requestHolibobCancellation: reservationID => api.post(`booking/holi/booking/${reservationID}/cancel`),
  sendUserPoints: data => api.post(`booking/points/purchase`, data),
  bookTravelLeisure: data => api.post(`booking/resorts/book`, data),
}

export default bookingEndpoints